import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './ProdutosSection.css';

import chicote1 from "../../imagens/wires/chicoteCarrossel1.jpeg";
import chicote2 from "../../imagens/wires/chicoteCarrossel2.jpeg";
import chicote3 from "../../imagens/wires/chicoteCarrossel3.jpeg";
import { useTranslation } from "react-i18next";

const imagens = [chicote1, chicote2, chicote3];

const ProdutosSection = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const carouselElement = document.querySelector('#produtosCarousel');

    // Carrossel já inicia automaticamente graças aos data-attributes
    // mas isso força o início mesmo se o Bootstrap "falhar"
    if (carouselElement) {
      const bsCarousel = new window.bootstrap.Carousel(carouselElement, {
        interval: 3000,
        ride: "carousel"
      });
    }
  }, []);

  return (
    <section className="produtos-section position-relative d-flex align-items-center">

      {/* === Carrossel de fundo === */}
      <div
        id="produtosCarousel"
        className="carousel slide carousel-fade position-absolute w-100 h-100"
        data-bs-ride="carousel"
        data-bs-interval="3000"
        data-bs-wrap="true"
        data-bs-pause="false"
      >
        <div className="carousel-inner h-100">
          {imagens.map((img, index) => (
            <div
              key={index}
              className={`carousel-item h-100 ${index === 0 ? "active" : ""}`}
              style={{
                backgroundImage: `url(${img})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat"
              }}
            ></div>
          ))}
        </div>
      </div>

      {/* Overlay escuro */}
      <div className="produtos-overlay"></div>

      {/* === Conteúdo === */}
      <div className="produtos-content text-white text-start">
        <h3 className="produtos-title mb-3">{t("homeProdutos.title")}</h3>
        <p className="produtos-text mb-4">{t("homeProdutos.description1")}</p>
        <p className="produtos-text mb-4">{t("homeProdutos.description2")}</p>

        <a href="/Capabilities/Production" className="btn btn-success fw-bold px-4 py-2">
          {t("homeProdutos.button")}
        </a>
      </div>

    </section>
  );
};

export default ProdutosSection;
